import { useWindowSize } from '@starrez/starryui9';
import React, { createRef, FC } from 'react';
import styled from 'styled-components';

let containerWidth = 0;

export const OverlayWrapper: FC = ({ children }) => {
    const ref = createRef<HTMLDivElement>();
    const windowSize = useWindowSize();
    
    const grid = document.querySelector('[id^="ui-grid"]');
    const box = grid?.getBoundingClientRect();

    // When grid is scrolled horizontally box.left becomes negative
    if (box?.left && windowSize.width && box?.left > 0) {
        containerWidth = windowSize.width - box.left;
    }

    return (
        <Wrapper ref={ref}>
            <Container style={{ width: containerWidth ? containerWidth : 'auto' }}>{children}</Container>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    position: absolute;
    top: 60px;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: white;
`;

const Container = styled.div`
    position: sticky;
    left: 0;
    padding: 50px;
    background-color: white;
`;
